import _slicedToArray from "/Users/jonthornton/Sites/ministry-of-eco-education-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { A as en, B as tn, C as nn, D as rn, E as an, F as on, G as sn, H as un, I as fn, J as cn, c as Tt, d as Mt, e as Ut, f as At, g as Dt, h as Pt, i as Vt, j as Ft, k as Wt, l as _t, m as kt, n as Nt, o as Ht, p as Gt, q as qt, r as $t, s as Kt, t as jt, u as Jt, v as Bt, w as Qt, x as Xt, y as Yt, z as Zt } from "./chunk-J77JZQ3B.js";
import le from "react";
function tt(e, r) {
  if (!e) throw typeof r == "string" ? new Error(r) : new Error("".concat(r.displayName, " not found"));
}
var q = function q(e, r) {
  var _ref = r || {},
    _ref$assertCtxFn = _ref.assertCtxFn,
    t = _ref$assertCtxFn === void 0 ? tt : _ref$assertCtxFn,
    n = le.createContext(void 0);
  return n.displayName = e, [n, function () {
    var s = le.useContext(n);
    return t(s, "".concat(e, " not found")), s.value;
  }, function () {
    var s = le.useContext(n);
    return s ? s.value : {};
  }];
};
var _q = q("ClerkInstanceContext"),
  _q2 = _slicedToArray(_q, 2),
  mn = _q2[0],
  $ = _q2[1],
  _q3 = q("UserContext"),
  _q4 = _slicedToArray(_q3, 2),
  gn = _q4[0],
  Te = _q4[1],
  _q5 = q("ClientContext"),
  _q6 = _slicedToArray(_q5, 2),
  hn = _q6[0],
  pn = _q6[1],
  _q7 = q("SessionContext"),
  _q8 = _slicedToArray(_q7, 2),
  On = _q8[0],
  Me = _q8[1],
  _q9 = q("OrganizationContext"),
  _q10 = _slicedToArray(_q9, 2),
  bn = _q10[0],
  Ue = _q10[1];
import { useEffect as nt, useLayoutEffect as rt, createContext as it, useContext as Ve, useState as Fe, createElement as at, useRef as _, useCallback as ge, useDebugValue as ot } from "react";
function We(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function (s) {
      s(i);
    });
  }
  return new (t || (t = Promise))(function (i, s) {
    function f(c) {
      try {
        u(n.next(c));
      } catch (v) {
        s(v);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (v) {
        s(v);
      }
    }
    function u(c) {
      c.done ? i(c.value) : a(c.value).then(f, l);
    }
    u((n = n.apply(e, r || [])).next());
  });
}
function _e(e, r) {
  var t = {
      label: 0,
      sent: function sent() {
        if (i[0] & 1) throw i[1];
        return i[1];
      },
      trys: [],
      ops: []
    },
    n,
    a,
    i,
    s;
  return s = {
    next: f(0),
    throw: f(1),
    return: f(2)
  }, typeof Symbol == "function" && (s[Symbol.iterator] = function () {
    return this;
  }), s;
  function f(u) {
    return function (c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t;) {
      try {
        if (n = 1, a && (i = u[0] & 2 ? a.return : u[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, u[1])).done) return i;
        switch (a = 0, i && (u = [u[0] & 2, i.value]), u[0]) {
          case 0:
          case 1:
            i = u;
            break;
          case 4:
            return t.label++, {
              value: u[1],
              done: !1
            };
          case 5:
            t.label++, a = u[1], u = [0];
            continue;
          case 7:
            u = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              t = 0;
              continue;
            }
            if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
              t.label = u[1];
              break;
            }
            if (u[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = u;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(u);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        u = r.call(e, t);
      } catch (c) {
        u = [6, c], a = 0;
      } finally {
        n = i = 0;
      }
    }
    if (u[0] & 5) throw u[1];
    return {
      value: u[0] ? u[1] : void 0,
      done: !0
    };
  }
}
var S = function S() {},
  h = S(),
  Y = Object,
  O = function O(e) {
    return e === h;
  },
  D = function D(e) {
    return typeof e == "function";
  },
  M = function M(e, r) {
    return Y.assign({}, e, r);
  },
  Ce = "undefined",
  Re = function Re() {
    return typeof window != Ce;
  },
  st = function st() {
    return typeof document != Ce;
  },
  ut = function ut() {
    return Re() && typeof window.requestAnimationFrame != Ce;
  },
  ie = new WeakMap(),
  ft = 0,
  te = function te(e) {
    var r = typeof e,
      t = e && e.constructor,
      n = t == Date,
      a,
      i;
    if (Y(e) === e && !n && t != RegExp) {
      if (a = ie.get(e), a) return a;
      if (a = ++ft + "~", ie.set(e, a), t == Array) {
        for (a = "@", i = 0; i < e.length; i++) {
          a += te(e[i]) + ",";
        }
        ie.set(e, a);
      }
      if (t == Y) {
        a = "#";
        for (var s = Y.keys(e).sort(); !O(i = s.pop());) {
          O(e[i]) || (a += i + ":" + te(e[i]) + ",");
        }
        ie.set(e, a);
      }
    } else a = n ? e.toJSON() : r == "symbol" ? e.toString() : r == "string" ? JSON.stringify(e) : "" + e;
    return a;
  },
  he = !0,
  ct = function ct() {
    return he;
  },
  ke = Re(),
  xe = st(),
  pe = ke && window.addEventListener ? window.addEventListener.bind(window) : S,
  dt = xe ? document.addEventListener.bind(document) : S,
  Oe = ke && window.removeEventListener ? window.removeEventListener.bind(window) : S,
  lt = xe ? document.removeEventListener.bind(document) : S,
  vt = function vt() {
    var e = xe && document.visibilityState;
    return O(e) || e !== "hidden";
  },
  mt = function mt(e) {
    return dt("visibilitychange", e), pe("focus", e), function () {
      lt("visibilitychange", e), Oe("focus", e);
    };
  },
  gt = function gt(e) {
    var r = function r() {
        he = !0, e();
      },
      t = function t() {
        he = !1;
      };
    return pe("online", r), pe("offline", t), function () {
      Oe("online", r), Oe("offline", t);
    };
  },
  ht = {
    isOnline: ct,
    isVisible: vt
  },
  pt = {
    initFocus: mt,
    initReconnect: gt
  },
  ae = !Re() || "Deno" in window,
  Ot = function Ot(e) {
    return ut() ? window.requestAnimationFrame(e) : setTimeout(e, 1);
  },
  Z = ae ? nt : rt,
  ve = typeof navigator < "u" && navigator.connection,
  Ae = !ae && ve && (["slow-2g", "2g"].includes(ve.effectiveType) || ve.saveData),
  Ne = function Ne(e) {
    if (D(e)) try {
      e = e();
    } catch (_unused) {
      e = "";
    }
    var r = [].concat(e);
    e = typeof e == "string" ? e : (Array.isArray(e) ? e.length : e) ? te(e) : "";
    var t = e ? "$swr$" + e : "";
    return [e, r, t];
  },
  k = new WeakMap(),
  He = 0,
  Ge = 1,
  qe = 2,
  ee = function ee(e, r, t, n, a, i, s) {
    s === void 0 && (s = !0);
    var f = k.get(e),
      l = f[0],
      u = f[1],
      c = f[3],
      v = l[r],
      d = u[r];
    if (s && d) for (var R = 0; R < d.length; ++R) {
      d[R](t, n, a);
    }
    return i && (delete c[r], v && v[0]) ? v[0](qe).then(function () {
      return e.get(r);
    }) : e.get(r);
  },
  bt = 0,
  be = function be() {
    return ++bt;
  },
  $e = function $e() {
    for (var e = [], r = 0; r < arguments.length; r++) {
      e[r] = arguments[r];
    }
    return We(void 0, void 0, void 0, function () {
      var t, n, a, i, s, f, l, u, c, v, d, R, N, b, m, o, K, P, I, L, V;
      return _e(this, function (U) {
        switch (U.label) {
          case 0:
            if (t = e[0], n = e[1], a = e[2], i = e[3], s = typeof i == "boolean" ? {
              revalidate: i
            } : i || {}, f = O(s.populateCache) ? !0 : s.populateCache, l = s.revalidate !== !1, u = s.rollbackOnError !== !1, c = s.optimisticData, v = Ne(n), d = v[0], R = v[2], !d) return [2];
            if (N = k.get(t), b = N[2], e.length < 3) return [2, ee(t, d, t.get(d), h, h, l, !0)];
            if (m = a, K = be(), b[d] = [K, 0], P = !O(c), I = t.get(d), P && (L = D(c) ? c(I) : c, t.set(d, L), ee(t, d, L)), D(m)) try {
              m = m(t.get(d));
            } catch (F) {
              o = F;
            }
            return m && D(m.then) ? [4, m.catch(function (F) {
              o = F;
            })] : [3, 2];
          case 1:
            if (m = U.sent(), K !== b[d][0]) {
              if (o) throw o;
              return [2, m];
            } else o && P && u && (f = !0, m = I, t.set(d, I));
            U.label = 2;
          case 2:
            return f && (o || (D(f) && (m = f(m, I)), t.set(d, m)), t.set(R, M(t.get(R), {
              error: o
            }))), b[d][1] = be(), [4, ee(t, d, m, o, h, l, !!f)];
          case 3:
            if (V = U.sent(), o) throw o;
            return [2, f ? V : m];
        }
      });
    });
  },
  De = function De(e, r) {
    for (var t in e) {
      e[t][0] && e[t][0](r);
    }
  },
  Ke = function Ke(e, r) {
    if (!k.has(e)) {
      var t = M(pt, r),
        n = {},
        a = $e.bind(h, e),
        i = S;
      if (k.set(e, [n, {}, {}, {}, a]), !ae) {
        var s = t.initFocus(setTimeout.bind(h, De.bind(h, n, He))),
          f = t.initReconnect(setTimeout.bind(h, De.bind(h, n, Ge)));
        i = function i() {
          s && s(), f && f(), k.delete(e);
        };
      }
      return [e, a, i];
    }
    return [e, k.get(e)[4]];
  },
  zt = function zt(e, r, t, n, a) {
    var i = t.errorRetryCount,
      s = a.retryCount,
      f = ~~((Math.random() + .5) * (1 << (s < 8 ? s : 8))) * t.errorRetryInterval;
    !O(i) && s > i || setTimeout(n, f, a);
  },
  je = Ke(new Map()),
  Je = je[0],
  Ct = je[1],
  Be = M({
    onLoadingSlow: S,
    onSuccess: S,
    onError: S,
    onErrorRetry: zt,
    onDiscarded: S,
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    errorRetryInterval: Ae ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: Ae ? 5e3 : 3e3,
    compare: function compare(e, r) {
      return te(e) == te(r);
    },
    isPaused: function isPaused() {
      return !1;
    },
    cache: Je,
    mutate: Ct,
    fallback: {}
  }, ht),
  Qe = function Qe(e, r) {
    var t = M(e, r);
    if (r) {
      var n = e.use,
        a = e.fallback,
        i = r.use,
        s = r.fallback;
      n && i && (t.use = n.concat(i)), a && s && (t.fallback = M(a, s));
    }
    return t;
  },
  ze = it({}),
  Rt = function Rt(e) {
    var r = e.value,
      t = Qe(Ve(ze), r),
      n = r && r.provider,
      a = Fe(function () {
        return n ? Ke(n(t.cache || Je), r) : h;
      })[0];
    return a && (t.cache = a[0], t.mutate = a[1]), Z(function () {
      return a ? a[2] : h;
    }, []), at(ze.Provider, M(e, {
      value: t
    }));
  },
  xt = function xt(e, r) {
    var t = Fe({})[1],
      n = _(e),
      a = _({
        data: !1,
        error: !1,
        isValidating: !1
      }),
      i = ge(function (s) {
        var f = !1,
          l = n.current;
        for (var u in s) {
          var c = u;
          l[c] !== s[c] && (l[c] = s[c], a.current[c] && (f = !0));
        }
        f && !r.current && t({});
      }, []);
    return Z(function () {
      n.current = e;
    }), [n, a.current, i];
  },
  yt = function yt(e) {
    return D(e[1]) ? [e[0], e[1], e[2] || {}] : [e[0], null, (e[1] === null ? e[2] : e[1]) || {}];
  },
  Lt = function Lt() {
    return M(Be, Ve(ze));
  },
  wt = function wt(e) {
    return function () {
      for (var t = [], n = 0; n < arguments.length; n++) {
        t[n] = arguments[n];
      }
      var a = Lt(),
        i = yt(t),
        s = i[0],
        f = i[1],
        l = i[2],
        u = Qe(a, l),
        c = e,
        v = u.use;
      if (v) for (var d = v.length; d-- > 0;) {
        c = v[d](c);
      }
      return c(s, f || u.fetcher, u);
    };
  },
  Pe = function Pe(e, r, t) {
    var n = r[e] || (r[e] = []);
    return n.push(t), function () {
      var a = n.indexOf(t);
      a >= 0 && (n[a] = n[n.length - 1], n.pop());
    };
  },
  me = {
    dedupe: !0
  },
  Et = function Et(e, r, t) {
    var n = t.cache,
      a = t.compare,
      i = t.fallbackData,
      s = t.suspense,
      f = t.revalidateOnMount,
      l = t.refreshInterval,
      u = t.refreshWhenHidden,
      c = t.refreshWhenOffline,
      v = k.get(n),
      d = v[0],
      R = v[1],
      N = v[2],
      b = v[3],
      m = Ne(e),
      o = m[0],
      K = m[1],
      P = m[2],
      I = _(!1),
      L = _(!1),
      V = _(o),
      U = _(r),
      F = _(t),
      g = function g() {
        return F.current;
      },
      oe = function oe() {
        return g().isVisible() && g().isOnline();
      },
      ne = function ne(x) {
        return n.set(P, M(n.get(P), x));
      },
      Le = n.get(o),
      Ye = O(i) ? t.fallback[o] : i,
      T = O(Le) ? Ye : Le,
      we = n.get(P) || {},
      j = we.error,
      Ee = !I.current,
      Se = function Se() {
        return Ee && !O(f) ? f : g().isPaused() ? !1 : s ? O(T) ? !1 : t.revalidateIfStale : O(T) || t.revalidateIfStale;
      },
      Ze = function Ze() {
        return !o || !r ? !1 : we.isValidating ? !0 : Ee && Se();
      },
      se = Ze(),
      ue = xt({
        data: T,
        error: j,
        isValidating: se
      }, L),
      H = ue[0],
      fe = ue[1],
      re = ue[2],
      W = ge(function (x) {
        return We(void 0, void 0, void 0, function () {
          var z, C, y, J, B, w, p, A, E, ce, Q, G, de;
          return _e(this, function (X) {
            switch (X.label) {
              case 0:
                if (z = U.current, !o || !z || L.current || g().isPaused()) return [2, !1];
                J = !0, B = x || {}, w = !b[o] || !B.dedupe, p = function p() {
                  return !L.current && o === V.current && I.current;
                }, A = function A() {
                  var Ie = b[o];
                  Ie && Ie[1] === y && delete b[o];
                }, E = {
                  isValidating: !1
                }, ce = function ce() {
                  ne({
                    isValidating: !1
                  }), p() && re(E);
                }, ne({
                  isValidating: !0
                }), re({
                  isValidating: !0
                }), X.label = 1;
              case 1:
                return X.trys.push([1, 3,, 4]), w && (ee(n, o, H.current.data, H.current.error, !0), t.loadingTimeout && !n.get(o) && setTimeout(function () {
                  J && p() && g().onLoadingSlow(o, t);
                }, t.loadingTimeout), b[o] = [z.apply(void 0, K), be()]), de = b[o], C = de[0], y = de[1], [4, C];
              case 2:
                return C = X.sent(), w && setTimeout(A, t.dedupingInterval), !b[o] || b[o][1] !== y ? (w && p() && g().onDiscarded(o), [2, !1]) : (ne({
                  error: h
                }), E.error = h, Q = N[o], !O(Q) && (y <= Q[0] || y <= Q[1] || Q[1] === 0) ? (ce(), w && p() && g().onDiscarded(o), [2, !1]) : (a(H.current.data, C) ? E.data = H.current.data : E.data = C, a(n.get(o), C) || n.set(o, C), w && p() && g().onSuccess(C, o, t), [3, 4]));
              case 3:
                return G = X.sent(), A(), g().isPaused() || (ne({
                  error: G
                }), E.error = G, w && p() && (g().onError(G, o, t), (typeof t.shouldRetryOnError == "boolean" && t.shouldRetryOnError || D(t.shouldRetryOnError) && t.shouldRetryOnError(G)) && oe() && g().onErrorRetry(G, o, t, W, {
                  retryCount: (B.retryCount || 0) + 1,
                  dedupe: !0
                }))), [3, 4];
              case 4:
                return J = !1, ce(), p() && w && ee(n, o, E.data, E.error, !1), [2, !0];
            }
          });
        });
      }, [o]),
      et = ge($e.bind(h, n, function () {
        return V.current;
      }), []);
    if (Z(function () {
      U.current = r, F.current = t;
    }), Z(function () {
      if (!!o) {
        var x = o !== V.current,
          z = W.bind(h, me),
          C = function C(p, A, E) {
            re(M({
              error: A,
              isValidating: E
            }, a(H.current.data, p) ? h : {
              data: p
            }));
          },
          y = 0,
          J = function J(p) {
            if (p == He) {
              var A = Date.now();
              g().revalidateOnFocus && A > y && oe() && (y = A + g().focusThrottleInterval, z());
            } else if (p == Ge) g().revalidateOnReconnect && oe() && z();else if (p == qe) return W();
          },
          B = Pe(o, R, C),
          w = Pe(o, d, J);
        return L.current = !1, V.current = o, I.current = !0, x && re({
          data: T,
          error: j,
          isValidating: se
        }), Se() && (O(T) || ae ? z() : Ot(z)), function () {
          L.current = !0, B(), w();
        };
      }
    }, [o, W]), Z(function () {
      var x;
      function z() {
        var y = D(l) ? l(T) : l;
        y && x !== -1 && (x = setTimeout(C, y));
      }
      function C() {
        !H.current.error && (u || g().isVisible()) && (c || g().isOnline()) ? W(me).then(z) : z();
      }
      return z(), function () {
        x && (clearTimeout(x), x = -1);
      };
    }, [l, u, c, W]), ot(T), s && O(T) && o) throw U.current = r, F.current = t, L.current = !1, O(j) ? W(me) : j;
    return {
      mutate: et,
      get data() {
        return fe.data = !0, T;
      },
      get error() {
        return fe.error = !0, j;
      },
      get isValidating() {
        return fe.isValidating = !0, se;
      }
    };
  },
  Rn = Y.defineProperty(Rt, "default", {
    value: Be
  });
var ye = wt(Et);
var wn = function wn(e) {
  var _ref2 = e || {},
    r = _ref2.invitationList,
    t = _ref2.membershipList,
    _Ue = Ue(),
    n = _Ue.organization,
    a = _Ue.lastOrganizationMember,
    i = _Ue.lastOrganizationInvitation,
    s = Me(),
    f = $(),
    l = f.loaded && s && n,
    u = f.loaded ? function () {
      var o;
      return (o = f.organization) == null ? void 0 : o.getPendingInvitations(r);
    } : function () {
      return [];
    },
    c = f.loaded ? function () {
      var o;
      return (o = f.organization) == null ? void 0 : o.getMemberships(t);
    } : function () {
      return [];
    },
    _ye = ye(l && r ? Xe("invites", n, i, r) : null, u),
    v = _ye.data,
    d = _ye.isValidating,
    R = _ye.mutate,
    _ye2 = ye(l && t ? Xe("memberships", n, a, t) : null, c),
    N = _ye2.data,
    b = _ye2.isValidating,
    m = _ye2.mutate;
  return n === void 0 ? {
    isLoaded: !1,
    organization: void 0,
    invitationList: void 0,
    membershipList: void 0,
    membership: void 0
  } : n === null ? {
    isLoaded: !0,
    organization: null,
    invitationList: null,
    membershipList: null,
    membership: null
  } : !f.loaded && n ? {
    isLoaded: !0,
    organization: n,
    invitationList: void 0,
    membershipList: void 0,
    membership: void 0
  } : {
    isLoaded: !b && !d,
    organization: n,
    membershipList: N,
    membership: St(s.user.organizationMemberships, n.id),
    invitationList: v,
    unstable__mutate: function unstable__mutate() {
      m(), R();
    }
  };
};
function St(e, r) {
  return e.find(function (t) {
    return t.organization.id === r;
  });
}
function Xe(e, r, t, n) {
  return [e, r.id, t == null ? void 0 : t.id, t == null ? void 0 : t.updatedAt, n.offset, n.limit].filter(Boolean).join("-");
}
var In = function In() {
  var e = $(),
    r = Te();
  return !e.loaded || !r ? {
    isLoaded: !1,
    organizationList: void 0,
    createOrganization: void 0,
    setActive: void 0
  } : {
    isLoaded: !0,
    organizationList: It(r.organizationMemberships),
    setActive: e.setActive,
    createOrganization: e.createOrganization
  };
};
function It(e) {
  return e.map(function (r) {
    return {
      membership: r,
      organization: r.organization
    };
  });
}
var Un = function Un() {
  var e = $();
  return e.loaded ? {
    isLoaded: !0,
    createOrganization: e.createOrganization,
    getOrganizationMemberships: e.getOrganizationMemberships,
    getOrganization: e.getOrganization
  } : {
    isLoaded: !1,
    createOrganization: void 0,
    getOrganizationMemberships: void 0,
    getOrganization: void 0
  };
};
export { mn as ClerkInstanceContext, hn as ClientContext, Xt as LocalStorageBroadcastChannel, bn as OrganizationContext, un as Poller, On as SessionContext, gn as UserContext, Jt as addYears, tt as assertContextExists, rn as camelToSnake, Nt as colorToSameTypeString, q as createContextAndHook, Gt as createCookieHandler, sn as createWorkerTimers, qt as dateTo12HourTime, an as deepCamelToSnake, on as deepSnakeToCamel, $t as differenceInCalendarDays, Yt as extension, jt as formatRelative, Wt as hasAlpha, Ht as hexStringToRgbaColor, Mt as inBrowser, fn as inClientSide, Vt as isHSLColor, en as isIPV4Address, Pt as isRGBColor, Qt as isRetinaDisplay, Ft as isTransparent, Ut as isValidHexString, Dt as isValidHslaString, At as isValidRgbaString, Zt as noop, Kt as normalizeDate, cn as parseSearchParams, Bt as readJSONFile, nn as snakeToCamel, _t as stringToHslaColor, kt as stringToSameTypeColor, tn as titleize, Tt as toSentence, $ as useClerkInstanceContext, pn as useClientContext, wn as useOrganization, Ue as useOrganizationContext, In as useOrganizationList, Un as useOrganizations, Me as useSessionContext, Te as useUserContext };
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */